import { api } from '../lib/api';

export interface DriftplanColumn {
  key: string;
  header: string;
  sortOrder: number;
  columnType: string;
  valueListKey: string | null;
}

export interface DriftplanTask {
  id: number;
  name: string;
  dueDate: string | null;
  done: boolean;
  doneDate: string | null;
  sortOrder: number;
}

export interface DriftplanRow {
  weekNumber: number;
  mondayDate: string;
  values: Record<string, string | null>;
  tasks: DriftplanTask[];
}

export interface DriftplanGrid {
  plan: {
    id: number;
    year: number;
    name: string;
    notes: string | null;
  };
  columns: DriftplanColumn[];
  rows: DriftplanRow[];
}

export const driftplanApi = {
  getGrid: (year: number) => api.get<DriftplanGrid>(`/driftplan?year=${encodeURIComponent(String(year))}`),
  listYears: () => api.get<{ years: number[] }>('/driftplan/years'),
  setCell: (payload: { year: number; weekNumber: number; columnKey: string; value: string }) =>
    api.put<{ ok: boolean }>('/driftplan/cell', payload),
  copyYear: (payload: { fromYear: number; toYear: number; columnKeys: string[] }) =>
    api.post<{ ok: boolean }>('/driftplan/copy-year', payload),
  createTask: (payload: { year: number; weekNumber: number; name: string; dueDate?: string | null }) =>
    api.post<{ id: number }>('/driftplan/tasks', payload),
  updateTask: (taskId: number, payload: { name?: string; dueDate?: string | null; done?: boolean; doneDate?: string | null; weekNumber?: number }) =>
    api.patch<{ ok: boolean }>(`/driftplan/tasks/${taskId}`, payload),
};
